var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var FourthNumberImage = function () {
    return (_jsx("svg", __assign({ width: "96", height: "105", viewBox: "0 0 96 105", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M0.1 81.15V67.65L51.85 -7.15256e-06H72.7L21.7 67.65L11.95 64.65H95.2V81.15H0.1ZM57.7 105V81.15L58.3 64.65V43.5H76.6V105H57.7Z", fill: "#CDCDCD", fillOpacity: "0.26" }) })));
};
